<template>
  <div class="docpc-steps-content">
    <div :class="type=='exam'?'docpc-steps-exam':'docpc-steps'">
      <div class="step" v-for="(item,index) in list" :key="index" :class="{'on':(active!=null&&active>=index)}">
        <div class="step-num">{{index+1}}</div>
        <div class="step-name">{{item}}</div>
        <div class="step-arrow"></div>
      </div>
    </div>
    <div class="docpc-topbar" v-if="docpc.docpcInfo">
      <div class="docpc-logout" @click="logout()">退出登录</div>
    </div>
  </div>
</template>

<script>
import {
  doctorLogout
} from '@/api/doctorapi';
import {
  Toast, Dialog
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcSteps',
  props: {
    type: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: ()=>['申请注册','培训考试','备案提交','印章接收','项目授权']
    },
    current: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      themeColor: this.themeColor,
      active: 0,
      btnDisabled: false
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  watch: {
    current: {
      handler(newVal, oldVal) {
        this.active = newVal
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['CLEAR_DOCPC_INFO','CLEAR_DOCPC_FORM']),
    logout() {
      if (this.btnDisabled) {
        return
      }
      Dialog.confirm({
        message: '确认要退出该账号吗？',
      }).then(() => {
        // on confirm
        this.btnDisabled = true
        doctorLogout({id: this.docpc.docpcInfo.doctor.id}).then(res => {
          console.log('doctorLogout', res.data)
          this.CLEAR_DOCPC_INFO()
          this.CLEAR_DOCPC_FORM()
          this.btnDisabled = false
          this.$router.replace({
            name: "docpcLogin",
          });
        }).catch(err => {
          this.btnDisabled = false
          Toast(err.response.data.message)
        })
      })
      .catch(() => {
        // on cancel
      });
    }
  }
}
</script>

<style lang="less" scope>
.docpc-steps-content {
  
  .docpc-topbar {
    margin: 0 10px; position: relative;
    .docpc-logout {
      position: absolute; right: 0; z-index: 100; background: linear-gradient(to bottom, #fff 0%, #f6fafb 100%); padding: 0 12px 0 22px; line-height: 34px; height: 34px; border-radius: 0 0 0 34px; box-shadow: 0 3px 3px #eee; font-size: 12px; color: #666; cursor: pointer;
    }
  }
}
.docpc-steps {
  display: flex; align-items: center; width: 90%; margin: 0 auto 28px;
  .step {
    flex: 1; position: relative; display: flex; padding: 6px 5px 6px 30px; line-height: 22px; background: @docpc-grayf3;
    .step-num {
      width: 22px; height: 22px; line-height: 22px; text-align: center; overflow: hidden; border-radius: 100%; background: @docpc-color; color: #fff;
    }
    .step-name {
      flex: 1; min-width: 0; padding: 0 10px; white-space: nowrap;
    }
    .step-arrow {
      width: 30px; height: 34px; overflow: hidden; position: absolute; top: 0; right: -18px; z-index: 1;
      &::after {
        .arrow-r; border-color: #fff; border-width: 6px 6px 0 0; width: 40px; height: 40px; transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0); background: @docpc-grayf3; margin-top: -23px; right: 10px;
      }
    }
    &.on {
      background: @docpc-color; color: #fff;
      .step-num {
        background: #fff; color: @docpc-color;
      }
      .step-arrow {
        &::after {
          background: @docpc-color;
        }
      }
    }
    &:first-child {
      padding: 6px 5px 6px 20px;
    }
    &:last-child {
      .step-arrow {
        // display: none;
      }
    }
  }
}
.docpc-steps-exam {
  display: flex; align-items: center; width: 90%; margin: 0 auto 28px; justify-content: space-around;
  .step {
    position: relative; flex: 1; position: relative;
    &::after {
      content: ''; display: block; background: #f4f4f4; width: 100%; height: 7px; position: absolute; top: 18px; right: 50%;
    }
    .step-num {
      height: 42px; width: 42px; line-height: 42px; text-align: center; position: relative; color: #666; font-size: 14px; z-index: 1; margin: auto;
      &::after {
        content: ''; display: block; background: #fff; box-shadow: 0 0 0 1px #eee; width: 30px; height: 30px; transform: rotate(45deg); position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; z-index: -1;
      }
    }
    .step-name {
      text-align: center; padding: 10px 5px; font-size: 14px;
    }
    &.on {
      &::after {
        background: @docpc-color; 
      }
      .step-num {
        color: #fff;
        &::after {
           background: @docpc-color; box-shadow: none;
        }
      }
    }
    &:first-child {
      &::after {
        display: none;
      }
    }
  }
}
</style>